import * as d3 from 'd3';

export const drawBarGraph = (data = []) => {
	const MARGINS = { left: 50, right: 10, top: 20, bottom: 80 };
	const WIDTH = 700 - MARGINS.left - MARGINS.right;
	const HEIGHT = 500 - MARGINS.top - MARGINS.bottom;

	d3.select('#volume-time-graph')
		.select('svg')
		.remove();
	const xScale = d3.scaleBand()
		.domain(data.map((data) => data.year_month))
		.range([0, WIDTH])
		.padding(0.5);

	const yScale = d3.scaleLinear()
		.domain([0, d3.max(data, d => d.volume) + 5])
		.range([HEIGHT, 0]);

	const graphContainer = d3.select("#volume-time-graph")
		.append('svg')
		.attr("width", WIDTH + MARGINS.left + MARGINS.right)
		.attr('height', HEIGHT + MARGINS.top + MARGINS.bottom)
		.attr('preserveAspectRatio', 'xMinYMin meet')
		.attr('viewBox', `0 0 ${WIDTH + MARGINS.left + MARGINS.right} ${HEIGHT + MARGINS.top + MARGINS.bottom} `);

	const graph = graphContainer.append('g')
		.attr('transform', `translate(${MARGINS.left}, ${MARGINS.top})`);

	const wrapInTwoLines = (text) => {
		text.each(function () {
			let text = d3.select(this),
				words = text.text().split(/\s+/),
				lineNumber = 0,
				lineHeight = 1.1,
				y = text.attr("y"),
				dy = parseFloat(text.attr("dy"));
			text.text(null);
			text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(words[0]);
			text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(words[1])
		});
	}

	const xAxisCall = d3.axisBottom(xScale)
		.tickSizeOuter(0)
		.tickSizeInner(0)
	if (data.length <= 6) {
		graph.append('g')
			.attr('class', 'horizontal-lines')
			.attr('transform', `translate(0, ${HEIGHT})`)
			.attr('color', '#e6eaee')
			.call(xAxisCall)
			.selectAll('text')
			.call(wrapInTwoLines)
			.attr('font-size', '12px')
			.attr('color', '#544e4a')
			.attr('y', '15')
			.attr('x', '0')
			.attr('text-anchor', 'middle')
			.attr('transform', 'rotate(0)');
	} else {
		graph.append('g')
			.attr('class', 'horizontal-lines')
			.attr('transform', `translate(0, ${HEIGHT})`)
			.attr('color', '#e6eaee')
			.call(xAxisCall)
			.selectAll('text')
			.attr('font-size', '12px')
			.attr('color', '#544e4a')
			.attr('x', '-15')
			.attr('y', '-5')
			.attr('text-anchor', 'end')
			.attr('transform', 'rotate(-90)');
	}

	const horizontalGridlines = d3.axisLeft(yScale).tickSize(-WIDTH).tickFormat('');
	graph.append('g')
		.attr('color', '#e6eaee')
		.call(horizontalGridlines);

	const yAxisCall = d3.axisLeft(yScale)
		.tickSizeOuter(0)
		.tickSizeInner(0)
		.tickFormat((d) => {
			if (d === 0) {
				return 0;
			} else if (d >= 1000 && d < 1000000) {
				return `${d / 1000}K`
			} else if (d >= 1000000) {
				return `${d / 1000000}M`
			} else {
				return d
			}
		})
	graph.append('g')
		.attr('color', '#ffffff')
		.call(yAxisCall)
		.selectAll('text')
		.attr('font-size', '12px')
		.attr('color', '#726c66');


	const bar = graph.selectAll("rect")
		.data(data);

		graph.append("text")
		.attr("transform", "rotate(-90)")
		.attr("y", -50 )
		.attr("x", -HEIGHT/2)
		.attr("dy", "1em")
		.attr('fill', '#726c66')
		.style('font-size', '14px')
		.style("text-anchor", "middle")
		.text("Total API calls");

	bar.enter()
		.append('rect')
		.attr("x", (d) => xScale(d.year_month))
		.attr("y", d => yScale(d.volume))
		.attr("width", xScale.bandwidth())
		.attr('height', (d) => HEIGHT - yScale(d.volume))
		.attr('fill', '#7967ae')
}
